// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileColumnRow_wrapper__6i85D","rowItemTitle":"MobileColumnRow_rowItemTitle__pvhwa"};